export default {
  SET_INTERSTITIAL_DISABLED: 'SET_INTERSTITIAL_DISABLED',
};
